import { useMemo } from "react";
import { cn } from "@design-lab/shared/lib/tailwindcss";
import { SpaceHolder } from "@design-lab/shared/ui/SpaceHolder";
import { DeliveryDateValue, type DeliveryDateValueCallbackProps } from "./DeliveryDateValue";
import { type DeliveryDateInfo } from "../model/HeaderModes";

type DeliveryDateTextProps = {
  className?: string;
  deliveryDateInfo: DeliveryDateInfo;
  children?: (props: DeliveryDateValueCallbackProps) => React.ReactNode;
};

export function DeliveryDateText(props: DeliveryDateTextProps) {
  const { className, children, deliveryDateInfo } = props;

  const visibleItem = useMemo(() => {
    if (deliveryDateInfo.isLoading) {
      return "loading";
    }

    if (deliveryDateInfo.isOutOfStock) {
      return "outOfStock";
    }

    if (deliveryDateInfo.isError) {
      return "error";
    }

    if (deliveryDateInfo.valueFull) {
      return "value";
    }

    return undefined;
  }, [deliveryDateInfo]);

  return (
    <SpaceHolder className="items-center">
      <SpaceHolder.Item
        visible={visibleItem === "loading"}
        className="flex justify-center lg:justify-start"
      >
        <p className={cn("text-sm font-semibold text-gray-400", className)}>
          Calculating earliest delivery date
        </p>
      </SpaceHolder.Item>

      <SpaceHolder.Item
        visible={visibleItem === "outOfStock"}
        className="flex justify-center lg:justify-start"
      >
        <p className={cn("font-semibold text-gray-500", className)}>Out of Stock</p>
      </SpaceHolder.Item>

      <SpaceHolder.Item
        visible={visibleItem === "error"}
        className="flex justify-center lg:justify-start"
      >
        <p className={cn("font-semibold text-red-500", className)}>Error</p>
      </SpaceHolder.Item>

      <SpaceHolder.Item
        visible={visibleItem === "value"}
        className="flex justify-center lg:justify-start"
      >
        <DeliveryDateValue
          deliveryDateInfo={deliveryDateInfo}
          className={className}
          key={visibleItem === "value" ? deliveryDateInfo.valueFull : undefined}
        >
          {children}
        </DeliveryDateValue>
      </SpaceHolder.Item>
    </SpaceHolder>
  );
}
